import { useLanguage } from '../context/LanguageContext';
import { useContent } from '../context/ContentContext';
import {
  PHONE, PHONE2, WHATSAPP_NUMBER, EMAIL, ADDRESS,
  FACEBOOK_URL, WHATSAPP_LINK, CALL_LINK,
} from '../config';

// Merges CMS content with config.js fallbacks and returns normalized
// contact fields, localized where needed.
export default function useContact() {
  const { lang, t } = useLanguage();
  const { content } = useContent();
  const cms = content?.contact || {};

  const phone = cms.phone || PHONE;
  const phone2 = cms.phone2 || PHONE2;
  const whatsappNumber = cms.whatsapp_number || WHATSAPP_NUMBER;
  const email = cms.email || EMAIL;
  const facebookUrl = cms.facebook_url || FACEBOOK_URL;

  const address =
    cms.address?.[lang] ||
    cms.address?.en ||
    t?.contact?.info?.address ||
    ADDRESS;

  const hours =
    cms.hours?.[lang] ||
    cms.hours?.en ||
    t?.contact?.info?.hours ||
    'Mon–Sat: 9:00 AM – 6:00 PM';

  const whatsappLink =
    cms.whatsapp_number
      ? `https://wa.me/${whatsappNumber}?text=Hello%20sir%2C%20I%20am%20interested%20in%20your%20agriculture%20machinery.`
      : WHATSAPP_LINK;

  const callLink = `tel:${phone.replace(/\s/g, '')}`;

  return {
    phone, phone2, whatsappNumber, email, address, hours,
    facebookUrl, whatsappLink, callLink,
  };
}
